/** Function that does nothing */
export const noop = () => undefined;
/** Function that returns the first argument */
export const identity = (arg) => arg;
/** Resolves {@link PropertyProvider} function to the value */
export const resolveProperty = (val, origin) => typeof val === 'function' ? val.call(origin, origin) : val;
